import Vue from 'vue'
import Crumb from './crumb.vue'
import Chart from './chart.vue'
import Tables from './tables.vue'
import Gmt from './gmt.vue'
import Language from './language.vue'
import DataCenter from './data-center.vue'

import Dialogs from './dialogs.vue'

import './layout'

import ElYearPicker from './year-picker/index'

import WarnInfo from './warn-info.vue'

Vue.component('Crumb', Crumb)
Vue.component('Chart', Chart)
Vue.component('Tables', Tables)
Vue.component('Gmt', Gmt)
Vue.component('Language', Language)
Vue.component('DataCenter', DataCenter)

Vue.component('Dialogs', Dialogs)

Vue.component('ElYearPicker', ElYearPicker)

Vue.component('WarnInfo', WarnInfo)
